import React, { useEffect, useReducer } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { voterNameReducer, VoterNameContext } from "./voter-duckling.js";
import MatchupPage from "./components/matchup-page/matchup-page.js";
import Home from "./components/home/home.js";

import "./variables.css";

function App() {
  let [voter, dispatch] = useReducer(voterNameReducer, "");
  useEffect(() => dispatch({ type: "INIT" }), []);

  return (
    <VoterNameContext.Provider value={{ voter, dispatch }}>
      <Router>
        <Switch>
          <Route path="/:gameNumber">
            <MatchupPage />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </VoterNameContext.Provider>
  );
}

export default App;
